import NTPServersAdmin from "./NTPServers/component";
import DateAndTimeAdmin from "./DateAndTime/component";

const views = () => [
  {
    path: "/viewSysDate",
    view: DateAndTimeAdmin
  },
  {
    path: "/viewSysNtp",
    view: NTPServersAdmin,
  },
];

export default views;
